<!-- 企业匹配 -->
<template>
  <div v-show="certificationFlag == '1'">  
    <result ref="result"></result>
   </div>
   <div v-show="certificationFlag == '0'">
       <resultcopy ref="resultcopy"></resultcopy>
   </div> 

</template>
<script>
import { queryUserById,getUserInfoZqcli } from '@/api/home'

import { clickUrl, clickUrlToPhone,checkResearch,goCodeFirm } from '@/utils'
import resultcopy from '@/views/searchMatching/resultcopy'
import result from '@/views/searchMatching/result'
import purchase from '@/views/purchase/index'
import moment from 'moment'
import store from '@/store'
import { ZqcUrl, ZqcUrlCompanyone } from '@/config'

export default {
  name: 'EnterpriseMatchCopy',
  components: { result,purchase,resultcopy },
  data() {
    return {
      certificationFlag: '',
      isVip: false,
      zqcljInfo: {}
    }
  },
  mounted() {
    this.getUserInfo()
    this.getUserInfoZqc()
  },
  methods: {
    async getUserInfo() {
      try {
        let res = await queryUserById()
          this.userInfo = res.result || {}
        let e_time = res.result.expiration_time ? res.result.expiration_time.replace(/-/g, '/') : null
        let expirationTime = new Date(e_time).getTime()
        let time = new Date().getTime()
        this.isVip = time < expirationTime ? 1 : 0
        this.userInfo.expiration_time_show = moment(res.result.expiration_time).format("YYYY年MM月DD日")
        this.certificationFlag = res.result.certification_flag
        goCodeFirm(this.userInfo)

        if (this.certificationFlag) {
          let queryParams = {
            company_name: res.result.company.name,
            name: res.result.company.name
          } || {}
              this.$refs.result.queryParams = this.$route.query.search ? JSON.parse(this.$route.query.search) : queryParams
              this.$refs.result.userId = res.result.id
              this.$refs.result.isVip = this.isVip
              this.$refs.result.userInfo = this.userInfo
              this.$refs.result.init()
          }
          else {
            this.$refs.purchase.source = 'match'
            this.$refs.purchase.getUserInfo()
          }
      } catch {
        this.certificationFlag = 0
       }
    },
     async getUserInfoZqc(){
      var that = this
      try {
        let res = await getUserInfoZqcli()
        that.zqcljInfo = res.result || {}
        if (!that.zqcljInfo.org_id || that.zqcljInfo.org_id == null) {
          return
        }
        sessionStorage.setItem('urlZct', location.href)
        if (that.zqcljInfo.status == 0) {
          window.location.href = window.location.origin + ZqcUrlCompanyone
          return;
        }
        if(that.zqcljInfo.questions && that.zqcljInfo.questions.length){
          checkResearch(that.zqcljInfo.questions)
        }
      }catch(res){
        if(res.status == 6){
          sessionStorage.setItem('urlZct', location.href)
          window.location.href = window.location.origin + ZqcUrlCompanyone
        }
      }
    },
    
  },
}
</script>
<style lang="scss" scoped>

</style>
